import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButtons from "./WhatsAppButtons";
import SmoothScroll from "./SmoothScroll";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function Layout() {
  return (
    <SmoothScroll>
      <div className="marketing-scope min-h-screen bg-bone font-body text-navy antialiased">
        <ScrollToTop />
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
        <WhatsAppButtons />
      </div>
    </SmoothScroll>
  );
}
